import React from "react";
import CroppedText from "sulu-admin-bundle/components/CroppedText";
import SingleSelect from "sulu-admin-bundle/components/SingleSelect";
import { toJS } from "mobx";

const Option = SingleSelect.Option;

const headerColums = (props) => {
    const firstname = props?.t("sulu_admin.match.firstname");
    const lastname = props?.t("sulu_admin.match.lastname");
    const role = props?.t("sulu_admin.match.function");

    const hC = (
        <div
            style={{
                display: "grid",
                gridTemplateColumns: "1.3fr repeat(6, 1fr)",
                width: "79.6%",
            }}
        >
            <div>{lastname}</div>
            <div>{firstname}</div>
            <div>{role}</div>
        </div>
    );

    return hC;
};

const inputNumb = (
    item,
    displayProperty,
    itemClickHandler,
    aditionalParams = "",
    data
) => {
    let roles = toJS(data.umpireRoleList);

    if (
        aditionalParams["umpireRoles"] &&
        aditionalParams["umpireRoles"].length > 0
    ) {
        roles = aditionalParams["umpireRoles"];
    }

    return (
        <div>
            <SingleSelect
                name={displayProperty}
                value={roles[item[displayProperty]] || ""}
                onChange={(value) => {
                    itemClickHandler(value, item.id, displayProperty);
                }}
            >
                {Object.values(roles).map((el, index) => {
                    return (
                        <Option key={index} value={el}>
                            {el}
                        </Option>
                    );
                })}
            </SingleSelect>
        </div>
    );
};
const columnCustom = (
    item,
    itemColumnClass,
    itemClickHandler,
    displayProperty,
    columns,
    inputNumb,
    aditionalParams = "",
    data
) => {
    const renderContent = () => {
        switch (displayProperty) {
            case "umpireRole":
                return inputNumb(
                    item,
                    displayProperty,
                    itemClickHandler,
                    aditionalParams,
                    data
                );
            case "lastName":
                return item.lastName;
            default:
                return <CroppedText>{item[displayProperty]}</CroppedText>;
        }
    };

    return (
        <div
            className={itemColumnClass}
            key={`${displayProperty}-${item.id}`}
            style={{ paddingLeft: "0" }}
        >
            {renderContent()}
        </div>
    );
};
const footer = (noOfSelectedPlayer) => {};

export { headerColums as hackHeader, inputNumb, columnCustom, footer };
